import { render } from "./GasTest.vue?vue&type=template&id=227aa544"
import script from "./GasTest.vue?vue&type=script&lang=js"
export * from "./GasTest.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__